module.exports = __webpack_public_path__ + "static/media/BovExo_template_identificar_animais.6419c6c0.xlsx";